import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '../schema';
import {assetNotCheckedOut} from './assetNotCheckedOut';

export const canReimportAsset = (asset?: IAsset) => {
	return (
		asset != null &&
		currentUserMeetsUserLevel(UserLevel.PRODUCER) &&
		allows(asset.permissionMatrix, PermissionMatrixName.MODIFY) &&
		assetNotCheckedOut(asset)
	);
};
